import{jsxs as e,jsx as r}from"react/jsx-runtime";import a from"clsx";import t,{cloneElement as i}from"react";import o from"tailwind-styled-components";import{twString as n}from"../utils.js";const l=o.div`
  bg-white
  border-gray-50
  border-t
  flex
  flex-col
  rounded-md
  shadow-brand-primary/10
  shadow-xl

  dark:bg-gray-700
  dark:border-gray-800
  dark:shadow-black/40
`,s=o.h2`
  flex-shrink-0
  font-semibold
  m-0
  p-4
  text-base
`,c=o.div`
  flex-grow
  px-4
  text-base
`,d=o.figure`
  mb-4
  overflow-hidden
  relative
`,g=o.img`
  -translate-x-1/2
  -translate-y-1/2
  absolute
  left-1/2
  m-0
  top-1/2
  w-full
`,b=o.div`
  border-gray-100
  border-t
  flex
  flex-shrink-0
  items-center
  mt-4
  p-4

  dark:border-gray-600
`,p=o.div`
  spacer
  flex-grow
`,h=o.button`
  inline-flex
  items-center
  p-2
  rounded-md
`,m=o.span`
  text-sm
`,f=o.iframe`
  bg-gray-900
  mb-4
  outline-none
  w-full
`,v=n`
  bg-brand-primary
  text-white
  hover:bg-brand-primary/90
`,x=n`
  bg-brand-accent
  text-white
  hover:bg-brand-accent/90
`,u=n`
  bg-red-500
  text-white
  hover:bg-red-500/90
`,w=n`
  bg-transparent
  text-gray-500
  hover:bg-gray-100
  dark:hover:bg-gray-600
`,y=n`
  bg-transparent
  shadow-[inset_0_0_0_1px_rgba(0,0,0,0.05)]
  hover:shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]
`,k=n`
  bg-green-500
  text-white
  hover:bg-green-500/90
`,_=n`
  bg-yellow-400
  text-yellow-900
  hover:bg-yellow-400/90
`,N=({actions:o=[],aspectRatio:n="video",children:N,className:P,imageSrc:j,header:q,videoSrc:C,...S})=>{const $=a({"aspect-auto":"auto"===n,"aspect-square":"square"===n,"aspect-video":"video"===n}),z=a(P,{"pt-4":!q,"pb-4":0===o?.length}),B=o.filter((e=>!e.align||"left"===e.align)),E=o.filter((e=>"right"===e.align)),O=[...B];return E.length>0&&O.push({},...E),e(l,{...S,children:[t.isValidElement(q)?q:q&&r(s,{children:q}),j&&r(d,{className:$,children:r(g,{src:j,alt:q})}),C&&r(f,{allow:"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",allowfullscreen:!0,className:$,frameBorder:"0",src:C}),r(c,{className:z,children:N}),o?.length>0&&r(b,{children:O.map(((t,n)=>{if(0===Object.keys(t).length)return r(p,{role:"separator"},`spacer-${n}`);const l=a({"rounded-full px-2":!t.label,"mr-2":n<o.length-1&&(!t.align||"left"===t.align),"px-4":t.label&&t.variant&&"ghost"!==t.variant,[v]:"primary"===t.variant,[x]:"accent"===t.variant,[u]:"danger"===t.variant,[w]:"ghost"===t.variant||!t.variant,[y]:"outline"===t.variant,[k]:"success"===t.variant,[_]:"warning"===t.variant,"pr-3":t.label&&t.icon&&"right"===t.iconPosition&&t.variant&&"ghost"!==t.variant,"pl-3":t.label&&t.icon&&(!t.iconPosition||"left"===t.iconPosition)&&t.variant&&"ghost"!==t.variant});return e(h,{className:l,onClick:t.onClick,children:[t.icon&&i(t.icon,{size:20,...t.icon.props,className:a(t.icon.props.className,"flex","text-lg",{"mr-2":t.label&&(!t.iconPosition||"left"===t.iconPosition),"ml-2":t.label&&"right"===t.iconPosition,"order-last":"right"===t.iconPosition})}),t.label&&r(m,{children:t.label})]},`action-${n}`)}))})]})};export{N as default};
